import { Link } from "react-router-dom";
import type { MediaItem } from "@/types/media";

interface MediaCardProps {
  item: MediaItem;
  index?: number;
}

export default function MediaCard({ item, index = 0 }: MediaCardProps) {
  const typeLabel = item.type === "movie" ? "电影" : "剧集";

  return (
    <Link
      to={`/detail/${item.id}`}
      className="group block cursor-pointer animate-fade-up"
      style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }}
    >
      <div className="relative h-[300px] w-full overflow-hidden rounded-lg bg-background-200 md:h-[340px]">
        <img
          src={item.poster}
          alt={`${item.title}海报`}
          title={`${item.title} - 蘑菇MOGU2影视详情`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950/85 via-primary-950/10 to-transparent"></div>
        <span className="absolute left-2 top-2 rounded-md bg-primary-500/90 px-2 py-0.5 text-xs font-medium text-background-50">
          {typeLabel}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-accent-500 px-2 py-0.5 text-xs font-bold text-primary-950">
          <i className="ri-star-fill text-[10px]"></i>
          {item.rating.toFixed(1)}
        </span>
        <div className="absolute bottom-0 left-0 right-0 p-3">
          <h3 className="truncate text-sm font-semibold text-white md:text-base">{item.title}</h3>
          <p className="mt-1 truncate text-xs text-background-200">
            {item.year} · {item.region} · {item.duration}
          </p>
        </div>
      </div>
      <div className="mt-2.5 flex flex-wrap gap-1.5">
        {item.genres.slice(0, 2).map((genre) => (
          <span
            key={genre}
            className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900"
          >
            {genre}
          </span>
        ))}
        <span className="truncate text-xs text-foreground-500">{item.cast[0]} 主演</span>
      </div>
    </Link>
  );
}